import { Pipe, PipeTransform } from '@angular/core';
import { UtilityService } from '../service/utility.service';

@Pipe({
  name: 'shortName'
})
export class ShortNamePipe implements PipeTransform {

  constructor(private utilService:UtilityService) { }

  transform(name: any): unknown {
    return this.utilService.getInitial(name);
  }

}
